import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const WorkExperienceDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Work Experience Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th>Department</th>
                  <th>Designation</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Salary</th>
                  {/* <th>Image</th> */}
                </tr>
              </thead>
              <tbody>
                {employee?.workExperienceDetails?.map((work) => (
                  <tr key={work.department}>
                    <td>{work.department}</td>
                    <td>{work.designation}</td>
                    <td>{work.weFromdate && format(new Date(work.weFromdate), "yyyy-MM-dd")}</td>
                    <td>{work.weTodate && format(new Date(work.weTodate), "yyyy-MM-dd")}</td>
                    <td>{work.salary}</td>
                    <td>
                      {work.image !== "" || work.image !== null
                        ? work.image
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

WorkExperienceDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default WorkExperienceDetails;
